import { styled, Stack, Box, Grid } from '../../../../base';

export const StyledCard = styled(Stack)(() => ({
    flex: 1,
}));

export const StyledHeader = styled(Grid)(({ theme }) => ({
    justifyContent: 'space-between',
    padding: theme.spacing(2),
    alignItems: 'center',
}));

export const StyledLegendRow = styled(Grid)(({ theme }) => ({
    gap: theme.spacing(1.5),
    flexWrap: 'wrap',
    justifyContent: "flex-end"
}));

export const StyledLegendItem = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
}));

export const StyledColorDot = styled('span')<{ dotColor: string }>(({ dotColor }) => ({
    display: 'inline-block',
    width: 10,
    height: 10,
    borderRadius: '50%',
    backgroundColor: dotColor,
    flexShrink: 0,
}));

export const StyledPieCard = styled(Stack)(({ theme }) => ({
    border: `1px solid ${theme.palette.grey[300]}`,
    borderRadius: 12,
    overflow: 'hidden',
}));

export const StyledPieCardHeader = styled(Box)(({ theme }) => ({
    padding: theme.spacing(2),
}));

export const StyledPieBody = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    padding: theme.spacing(2),
}));

export const StyledPieLegendRow = styled(Grid)(({ theme }) => ({
    gap: theme.spacing(0.5),
    alignItems: 'center',
}));
